import { render, staticRenderFns } from "./RecentNotifications.vue?vue&type=template&id=a7db033a&scoped=true&"
import script from "./RecentNotifications.vue?vue&type=script&lang=js&"
export * from "./RecentNotifications.vue?vue&type=script&lang=js&"
import style0 from "./RecentNotifications.vue?vue&type=style&index=0&id=a7db033a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7db033a",
  null
  
)

export default component.exports